import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <div className="cart-page__container">
          <div className="cart-empty">
            <div className="cart-empty__icon">🛒</div>
            <h2>Your Cart is Empty</h2>
            <p>Looks like you haven't added any items to your cart yet.</p>
            <Link to="/shop" onClick={toTop} className="continue-shopping-btn">
              Continue Shopping
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="cart-page__container">
        <nav className="breadcrumb">
          <Link to="/" onClick={toTop}>Home</Link>
          <span className="separator">/</span>
          <span className="current">Shopping Cart</span>
        </nav>

        <h1 className="cart-title">Shopping Cart</h1>

        <div className="cart-content">
          <div className="cart-items">
            {cartItems.map((item) => {
              const product = getProductById(item.id);
              if (!product) return null;
              
              const price = parseFloat(product.price.replace(/,/g, ""));
              const itemTotal = price * item.quantity;

              return (
                <div key={`${item.id}-${item.size}-${item.color}`} className="cart-item">
                  <Link 
                    to={`/product/${item.id}`} 
                    onClick={toTop}
                    className="cart-item__image-link"
                  >
                    <img 
                      src={product.image} 
                      alt={product.name} 
                      className="cart-item__image"
                    />
                  </Link>

                  <div className="cart-item__details">
                    <div className="cart-item__info">
                      <Link 
                        to={`/product/${item.id}`} 
                        onClick={toTop}
                        className="cart-item__name"
                      >
                        {product.name}
                      </Link>
                      <div className="cart-item__brand">{product.brand}</div>
                      <div className="cart-item__item-number">Item #: {product.itemNumber}</div>
                      
                      {(item.size && item.size !== "One Size") && (
                        <div className="cart-item__option">Size: {item.size}</div>
                      )}
                      {(item.color && item.color !== "Default") && (
                        <div className="cart-item__option">Color: {item.color}</div>
                      )}
                    </div>

                    <div className="cart-item__price">
                      <span className="cart-item__unit-price">${price.toFixed(2)} USD</span>
                    </div>

                    <div className="cart-item__quantity">
                      <button 
                        className="quantity-btn quantity-btn--decrease"
                        onClick={() => handleUpdateQuantity(item.id, item.size, item.color, item.quantity - 1)}
                      >
                        -
                      </button>
                      <span className="quantity-value">{item.quantity}</span>
                      <button 
                        className="quantity-btn quantity-btn--increase"
                        onClick={() => handleUpdateQuantity(item.id, item.size, item.color, item.quantity + 1)}
                      >
                        +
                      </button>
                    </div>

                    <div className="cart-item__total">
                      <span className="cart-item__total-price">${itemTotal.toFixed(2)} USD</span>
                    </div>

                    <button 
                      className="cart-item__remove"
                      onClick={() => removeFromCart(item.id, item.size, item.color)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="cart-summary">
            <div className="cart-summary__card">
              <h2 className="cart-summary__title">Order Summary</h2>
              
              <div className="cart-summary__row">
                <span className="cart-summary__label">Subtotal</span>
                <span className="cart-summary__value">${subtotal.toFixed(2)} USD</span>
              </div>
              
              <div className="cart-summary__row">
                <span className="cart-summary__label">Shipping</span>
                <span className="cart-summary__value">Calculated at checkout</span>
              </div>
              
              <div className="cart-summary__divider"></div>
              
              <div className="cart-summary__row cart-summary__row--total">
                <span className="cart-summary__label">Total</span>
                <span className="cart-summary__value">${subtotal.toFixed(2)} USD</span>
              </div>

              <button 
                className="checkout-btn"
                onClick={handleCheckout}
              >
                Proceed to Checkout
              </button>

              <Link 
                to="/shop" 
                onClick={toTop}
                className="continue-shopping-link"
              >
                ← Continue Shopping
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
